/* assets/sticky-atc.js
   スマホ用：商品ページのカートボタンを画面下部に固定するバー（案C）。

   設計方針（壊れにくさ優先）:
   - ボタンは複製しない。本物の <product-form> をバー内へ移設するだけ。
     → 売切れ/disabled/スピナー/カート投入はテーマ標準のまま自動で正しい（状態同期ゼロ）。
   - 価格は #price-{section} をミラー（Dawn の innerHTML 更新・variant-picker-airbnb の
     outerHTML 置換、両方の更新経路を MutationObserver + variantChange 購読でカバー）。
   - バリアント名は初期値を Liquid から受け取り、variantChange で更新。
   - PC幅では元の位置へ戻す。
   - JS が動かなくても、元位置の本物ボタンがそのまま機能する（フォールバック）。
*/
(() => {
  const MQ = '(max-width: 749px)';

  function init() {
    const productInfo = document.querySelector("product-info[id^='MainProduct-']");
    if (!productInfo) return;

    const bar = productInfo.querySelector('.sticky-atc');
    if (!bar || bar.dataset.ready === '1') return;

    const section = productInfo.dataset.section;

    // 主フォーム（定期便などの別フォームと取り違えない）
    const formEl = productInfo.querySelector('#product-form-' + section);
    const productForm = formEl ? formEl.closest('product-form') : productInfo.querySelector('product-form');

    // 本物のフォームが無い（在庫切れ静的表示など）場合はバーを出さない
    if (!productForm) {
      bar.remove();
      return;
    }
    bar.dataset.ready = '1';

    const priceDest = bar.querySelector('.sticky-atc__price');
    const offDest = bar.querySelector('.sticky-atc__off');
    const nameDest = bar.querySelector('.sticky-atc__variant');
    const actionSlot = bar.querySelector('.sticky-atc__action');

    // バリアント名更新用：バリアントID → タイトル の引き当てマップ。
    // airbnb ピッカーの data-variants（product.variants | json ＝ title を含む）から構築。
    const idInput = formEl ? formEl.querySelector('input[name="id"]') : null;
    const titleById = {};
    const picker = document.getElementById('variant-picker-airbnb-' + section);
    if (picker && picker.dataset.variants) {
      try {
        JSON.parse(picker.dataset.variants).forEach((v) => {
          if (v && v.id != null) titleById[v.id] = v.title;
        });
      } catch (_) {}
    }

    // フォームの元位置を記憶（PC幅で戻すため）
    const home = document.createComment('sticky-atc-form-home');
    productForm.parentNode.insertBefore(home, productForm);

    const mql = window.matchMedia(MQ);

    function measure() {
      fitPrice();
      const h = mql.matches ? bar.offsetHeight : 0;
      document.documentElement.style.setProperty('--sticky-atc-h', (h || 0) + 'px');
    }

    function place() {
      if (mql.matches) {
        if (productForm.parentNode !== actionSlot) actionSlot.appendChild(productForm);
      } else if (home.parentNode && productForm.parentNode !== home.parentNode) {
        home.parentNode.insertBefore(productForm, home);
      }
      // レイアウト確定後に高さ計測
      requestAnimationFrame(measure);
    }

    function copyPrice() {
      const src = document.getElementById('price-' + section);
      // バー内では「JPY」を除去して横幅を節約（全端末で被り防止）。
      // 通貨フォーマットを「円」表記に統一すれば JPY は元から無く、この処理は無害化される。
      if (src && priceDest) priceDest.innerHTML = src.innerHTML.replace(/\s*JPY/g, '');
      refreshOff();
      requestAnimationFrame(fitPrice);
    }

    // 高額商品(6桁等)で価格がボタンに重なる場合のみ比較(取り消し線)価格を隠す。
    // nowrap のテキストは箱(flexアイテム)からはみ出すため、境界矩形ではなく
    // scrollWidth > clientWidth の「あふれ」で判定する。
    // 一旦クラスを外して素の幅で判定するため、状態が変わらなければ DOM は元に戻るだけ。
    function fitPrice() {
      bar.classList.remove('sticky-atc--no-compare');
      if (!mql.matches || !priceDest) return;
      if (priceDest.scrollWidth > priceDest.clientWidth + 1) {
        bar.classList.add('sticky-atc--no-compare');
      }
    }

    // ミラーした価格DOMから割引率(%OFF)を算出。セール時のみ表示。
    // 価格の更新経路（Dawn / variant-picker-airbnb / variantChange）に依存せず常に同期。
    function refreshOff() {
      if (!offDest) return;
      const priceRoot = priceDest.querySelector('.price');
      const onSale = priceRoot && priceRoot.classList.contains('price--on-sale');
      const toNum = (el) => {
        if (!el) return null;
        const digits = el.textContent.replace(/[^\d]/g, '');
        return digits ? parseInt(digits, 10) : null;
      };
      const cmp = toNum(priceDest.querySelector('.price__sale .price-item--regular'));
      const sale = toNum(priceDest.querySelector('.price__sale .price-item--sale'));
      if (onSale && cmp && sale && cmp > sale) {
        offDest.textContent = Math.round(((cmp - sale) / cmp) * 100) + '%OFF';
        offDest.hidden = false;
      } else {
        offDest.hidden = true;
      }
    }

    function setName(title) {
      if (!nameDest) return;
      const t = title && title !== 'Default Title' ? title : '';
      nameDest.textContent = t;
      nameDest.classList.toggle('is-empty', t === '');
    }

    // バリアントID入力の変化から名前を更新。airbnb・Dawn どちらの経路でも id 入力に
    // change が発火するため、価格更新と同じく確実に同期する（variantChange に依存しない）。
    function updateNameFromId() {
      if (!idInput) return;
      const title = titleById[idInput.value];
      if (title != null) setName(title);
    }

    // ---- 初期化 ----
    copyPrice();
    setName(bar.dataset.variantTitle || '');
    updateNameFromId();
    if (idInput) {
      idInput.addEventListener('change', updateNameFromId);
      idInput.addEventListener('input', updateNameFromId);
    }
    place();

    if (mql.addEventListener) mql.addEventListener('change', place);
    else mql.addListener(place);

    window.addEventListener('resize', measure, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(measure).observe(bar);

    // 価格更新の監視。バー内の変化（=自分の書き込み）は無視して無限ループを防ぐ
    const container = document.getElementById('ProductInfo-' + section) || productInfo;
    let t;
    new MutationObserver((muts) => {
      if (muts.every((m) => bar.contains(m.target))) return;
      clearTimeout(t);
      t = setTimeout(copyPrice, 60);
    }).observe(container, { childList: true, subtree: true, characterData: true });

    // variantChange でも名前・価格を更新（保険）
    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
        subscribe(PUB_SUB_EVENTS.variantChange, (e) => {
          const v = e && e.data && e.data.variant;
          if (v) setName(v.title);
          copyPrice();
        });
      }
    } catch (_) {
      /* pub/sub 未ロード時は MutationObserver のミラーに任せる */
    }
  }

  document.addEventListener('DOMContentLoaded', init);
  // 別商品へのフルスワップ後など、product-info 再接続時にも初期化
  document.addEventListener('product-info:loaded', init);
})();
